export default __webpack_public_path__ + "static/media/img-soon-blue-block.5621676f.svg";